export interface ItemsPrivatePage {
  title?: string;
  titleKey?: string;
  icon?: string;
  route: string;
  sidebarActive?: boolean;
  children?: ItemsPrivatePage[];
}

export const itemsPrivatePage: ItemsPrivatePage[] = [
  {
    title: 'FINANCEIRO',
    titleKey: 'SIDEBAR.FINANCIAL',
    icon: 'fa-regular fa-money-bill-transfer',
    route: '/painel/financial',
    sidebarActive: true,
    children: [
      {
        title: 'FATURAS',
        titleKey: 'SIDEBAR.INVOICES',
        route: '/painel/financial/invoices',
        sidebarActive: true,
      }
    ]
  },
  {
    title: 'ASSINATURA',
    titleKey: 'SIDEBAR.SUBSCRIPTION',
    icon: 'fa-solid fa-user',
    route: '/painel/signature',
    sidebarActive: true,
    children: [
      {
        title: 'MUDAR PLANO',
        titleKey: 'SIDEBAR.CHANGE_PLAN',
        route: '/painel/signature/plans',
        sidebarActive: true,
      },
      {
        title: 'CONFIRMAR PLANO',
        titleKey: 'SIDEBAR.CONFIRM_PLAN',
        route: '/painel/signature/plans/confirm',
        sidebarActive: false
      },
      {
        title: 'PAGAMENTO',
        titleKey: 'SIDEBAR.PAYMENT',
        icon: 'fa-solid fa-money-bill-wave',
        route: '/painel/signature/plans/payments',
        sidebarActive: false,
        children: [
          {
            title: 'ESCOLHA',
            titleKey: 'SIDEBAR.PAYMENT_CHOICE',
            icon: 'fa-solid fa-money-bill-wave',
            route: '/painel/signature/plans/payments/choice',
            sidebarActive: false,
          },
          {
            title: 'PIX',
            titleKey: 'SIDEBAR.PAYMENT_PIX',
            icon: 'fa-solid fa-money-bill-wave',
            route: '/painel/signature/plans/payments/pix',
            sidebarActive: false,
          },
          {
            title: 'CARTAO',
            titleKey: 'SIDEBAR.PAYMENT_CARD',
            icon: 'fa-solid fa-money-bill-wave',
            route: '/painel/signature/plans/payments/card',
            sidebarActive: false,
          },
          {
            title: 'FORM',
            titleKey: 'SIDEBAR.PAYMENT_CARD_FORM',
            icon: 'fa-solid fa-money-bill-wave',
            route: '/painel/signature/plans/payments/card-form',
            sidebarActive: false,
          },
        ]
      },
      {
        title: 'VEÍCULOS',
        titleKey: 'SIDEBAR.VEHICLES',
        route: '/painel/signature/plans/vehicle',
        sidebarActive: false,
        children: [
          {
            title: 'CADASTRAR QR CODE',
            titleKey: 'SIDEBAR.VEHICLE_REGISTER_QR',
            route: '/painel/signature/plans/vehicle/register-qrcode',
            sidebarActive: false,
          }
        ]
      },
    ]
  },
];
